export default {
  'USERS': 'users', // user information
  'USER_TOKEN': 'token', // jwt token
  'SITE_HISTORY': 'siteList' // site name history list
}


// WEBPACK FOOTER //
// ./src/consts/storageKeys.js